export default __webpack_public_path__ + "static/media/maejemison.1d28fbde.jpg";